// extracted by mini-css-extract-plugin
module.exports = {"aboutFooter":"footer_aboutFooter__J5ikW","subscribeToNewsletter":"footer_subscribeToNewsletter__dxEwN"};